import ItemsPage from './ItemsPage';

// Thin wrapper: reuses ItemsPage with hobbies-only categories (toys, crafts,
// sports, books, stationary, musical instruments) — mirrors DefectedItemsPage.
const HobbiesFindsPage = () => <ItemsPage hobbiesOnly />;

export default HobbiesFindsPage;
